var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.224 3.473a10 10 0 013.651 3.918V3a.625.625 0 111.25 0v5c0 .897-.727 1.625-1.625 1.625h-5a.625.625 0 110-1.25h4.464a8.75 8.75 0 00-16.49 1.66.625.625 0 01-1.218-.281 10 10 0 0114.968-6.281zM3.125 16.608V21a.625.625 0 11-1.25 0v-5c0-.898.728-1.625 1.625-1.625h5a.625.625 0 110 1.25H4.036a8.75 8.75 0 0016.5-1.702.625.625 0 011.22.274 10.001 10.001 0 01-18.631 2.41z",
    fill: "currentColor"
  })));
}
export default SvgRefill;